import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteContent, bapuImage } from '../data/mock';
import { Heart, Users, Sparkles, BookOpen } from 'lucide-react';

const AboutSection = () => {
  const { language } = useLanguage();
  const content = siteContent[language].about;

  const missionIcons = [Heart, Users, Sparkles, BookOpen];

  return (
    <section id="about" className="py-16 md:py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-orange-800 mb-4">
            {content.title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-600 max-w-2xl mx-auto">
            {content.subtitle}
          </p>
          <div className="mt-6 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-orange-400 to-amber-400 rounded-full" />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image Section */}
          <div className="relative order-1 lg:order-none">
            <div className="absolute -inset-4 bg-gradient-to-br from-orange-200 to-amber-200 rounded-3xl blur-xl opacity-50" />
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={bapuImage}
                alt="Umedpuri Bapu"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-orange-900/30 to-transparent" />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-orange-400 to-amber-400 rounded-full flex items-center justify-center shadow-lg">
              <Sparkles className="w-8 h-8 md:w-10 md:h-10 text-white" />
            </div>
          </div>

          {/* Content Section */}
          <div className="space-y-4 md:space-y-6">
            {content.content.map((paragraph, index) => (
              <p
                key={index}
                className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg"
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Mission Section */}
        <div className="mt-16 md:mt-20">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-orange-800 text-center mb-8 md:mb-12">
            {content.mission.title}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {content.mission.points.map((point, index) => {
              const IconComponent = missionIcons[index];
              return (
                <div
                  key={index}
                  className="group p-5 md:p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-300"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-orange-400 to-amber-400 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-6 h-6 md:w-7 md:h-7 text-white" />
                  </div>
                  <p className="text-gray-700 font-medium text-sm md:text-base">{point}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
